<div class="wrapper">
    <mat-spinner
        *ngIf="isLoading"
        class="loader"
        [strokeWidth]="2"
        [diameter]="24"
    ></mat-spinner>

    <ng-container *ngIf="!isLoading">
        <div *ngIf="!isHiddenFirstLock" class="switch-blocked-wrapper">
            <div class="column-left">
                <div [ngClass]="{'is-active': blockedOutFirstConfirmValue}" class="blocked-status-icon">
                    <i class="pi pi-lock icon lock"></i>
                    <i class="pi pi-lock-open icon un-lock"></i>
                </div>
                <span class="blocked-title">{{'blocked'|translate}} <span class="bold">{{ blockedOutFirstConfirmValue ? ('blockeOn' | translate) : ('blockeOff' | translate) }}</span> OUT1</span>
            </div>
            <ng-container [ngSwitch]="_vehicle.St">
                <ng-container *ngSwitchCase="VehicleStatusEnum.Disconnected">
                    <img
                        [pTooltip]="'problemWithDevice'|translate"
                        tooltipPosition="top"
                        tooltipStyleClass="tooltip-pinned"
                        class="disconnected-icon"
                        src="/assets/images/vehicles/i-disconnected.svg"
                        alt=""
                    >
                </ng-container>
                <ng-container *ngSwitchCase="VehicleStatusEnum.Moving">
                    <img 
                        [pTooltip]="'lockingOnlyInParkingStatus'|translate"
                        tooltipPosition="top"
                        tooltipStyleClass="tooltip-pinned"
                        class="disconnected-icon"
                        src="/assets/images/vehicles/i-driving.svg"
                        alt=""
                    >
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <p-progressSpinner
                        *ngIf="isChaningOUT1Lock"
                        strokeWidth="3"
                        [style]="{ width: '20px', height: '20px'}"
                    ></p-progressSpinner>
                    <p-inputSwitch 
                        *ngIf="!isChaningOUT1Lock" 
                        [(ngModel)]="blockedOutFirst"
                        [disabled]="!userCanChangeStateBlocker" 
                        (ngModelChange)="onChangeOutFirst.next($event)"
                    ></p-inputSwitch>
                </ng-container>
             </ng-container>
        </div>
        <div *ngIf="!isHiddenSecondLock" class="switch-blocked-wrapper" style="margin-top: 8px;">
            <div class="column-left">
                <div [ngClass]="{'is-active': blockedOutSecondConfirmValue}" class="blocked-status-icon">
                    <i class="pi pi-lock icon lock"></i>
                    <i class="pi pi-lock-open icon un-lock"></i>
                </div>
                <span class="blocked-title">{{'blocked'|translate}} <span class="bold">{{ blockedOutSecondConfirmValue ? ('blockeOn' | translate) : ('blockeOff' | translate) }}</span> OUT2</span>
            </div>
            <ng-container [ngSwitch]="_vehicle.St">
                <ng-container *ngSwitchCase="VehicleStatusEnum.Disconnected">
                    <img 
                        [pTooltip]="'problemWithDevice'|translate"
                        tooltipPosition="top"
                        tooltipStyleClass="tooltip-pinned"
                        class="disconnected-icon"
                        src="/assets/images/vehicles/i-disconnected.svg" alt=""
                    >
                </ng-container>
                <ng-container *ngSwitchCase="VehicleStatusEnum.Moving">
                    <img 
                        [pTooltip]="'lockingOnlyInParkingStatus'|translate"
                        tooltipPosition="top"
                        tooltipStyleClass="tooltip-pinned"
                        class="disconnected-icon"
                        src="/assets/images/vehicles/i-driving.svg"
                        alt=""
                    >
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <p-progressSpinner
                        *ngIf="isChaningOUT2Lock"
                        strokeWidth="3"
                        [style]="{ width: '20px', height: '20px'}"
                    ></p-progressSpinner>
                    <p-inputSwitch
                        *ngIf="!isChaningOUT2Lock"
                        [(ngModel)]="blockedOutSecond"
                        [disabled]="!userCanChangeStateBlocker"
                        (ngModelChange)="onChangeOutSecond.next($event)"
                    ></p-inputSwitch>
                </ng-container>
             </ng-container>
        </div>

        <span class="last-update-title">{{'update'|translate}}: <span class="bold">{{lastUpdated|statusTimeFormat}}</span></span>

        <div class="history-wrapper">
            <h1 class="history-wrapper__title">
                {{'actionHistory'|translate}}
            </h1>

            <div *ngFor="let item of historyLock" class="history-list-item">
                <span
                    [ngClass]="{'error': item.EntryType === VehicleHistoryLockType.FailedToTurnOn || item.EntryType === VehicleHistoryLockType.FailedToTurnOff }"
                    class="history-list-item__title"
                >
                    {{ item.Description }} {{ item.OutName }}
                </span>
                <div class="history-list-item__details">
                    <span>
                        {{ item.UserName }}
                    </span>
                    <span>{{ item.Timestamp | date:'dd.MM.yyyy HH:mm:ss' }}</span>
                </div>
            </div>

            <div
                *ngIf="!historyLock.length && !isLoadingHistoryLock"
                class="history-wrapper__empty-state"
            >
                <img src="/assets/img/empty-state-history-lock.svg" alt="">
                <span class="history-wrapper__empty-state__title">
                    {{'emptyStateHistoryLockTitle'|translate}}
                </span>
                <span class="history-wrapper__empty-state__description">
                    {{'emptyStateHistoryLockDescription'|translate}}
                </span>
            </div>

            <div class="history-wrapper__bottom-space-error"></div>
        </div>
    </ng-container>
</div>
